import classNames from "classnames";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDeleteDebitCardMutation } from "../../redux/features/payment/payment.api";
import { SingleCardDetails } from "../../redux/features/payment/payment.type";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { Icon } from "../icons/icon";
import { ConfirmationModal } from "../modals/app_modals/confirmationModal";

export const DebitCardLoader = () => {
  return (
    <div className="px-6 py-4 rounded-[8px] bg-pry-dark-green-400/5">
      <Skeleton
        width={"100%"}
        height={32}
        baseColor={SKELETON_BASE_COLOR}
        highlightColor={SKELETON_HIGHLIGHT_COLOR}
      />
    </div>
  );
};

export const DebitCard = ({
  cardDetails,
  onClick,
  enableDelete,
  className = "",
  onSuccess = () => {},
  id,
}: {
  cardDetails: SingleCardDetails;
  onClick?: () => void;
  enableDelete?: boolean;
  className?: string;
  onSuccess?: () => void;
  id: number;
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [deleteCard, { isLoading: deletingCard }] =
    useDeleteDebitCardMutation();

  return (
    <>
      <div
        className={classNames(
          `
          px-6 py-4 bg-pry-dark-green-400/5
          rounded-lg flex items-center gap-4 justify-between
          border-[2px] border-transparent
          transition-all diration-500
          bg-[url('assets/images/card_bg.svg')]
          bg-contain bg-no-repeat bg-[center_left_3rem]
          `,
          className
        )}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <p className="text-base font-bold">
          ****{cardDetails?.last4?.slice(-4)}
        </p>

        <p className="text-sm ">
          {cardDetails?.exp_month}/{cardDetails?.exp_year}
        </p>

        <Icon
          svg={cardDetails?.card_type === "visa" ? "visa" : "mastercard"}
          width={cardDetails?.card_type === "visa" ? 32 : 24}
          height={cardDetails?.card_type === "visa" ? 32 : 24}
          className="ml-auto"
        />

        {enableDelete ? (
          <div className="flex-1 flex justify-end">
            <button
              type="button"
              className={`
              bg-white p-2 rounded-full text-red-200
              cursor-pointer border
              hover:scale-[0.95]
              hover:bg-lighter-red-bg
              hover:border-red-200
              transition-all duration-300
              `}
              onClick={() => {
                setDeleteModalOpen(true);
              }}
            >
              <Icon svg={"delete-icon"} width={20} height={20} className={""} />
            </button>
          </div>
        ) : undefined}
      </div>

      <ConfirmationModal
        isModalOpen={deleteModalOpen}
        onModalClose={() => {
          setDeleteModalOpen(false);
        }}
        title={"Confirm card deletion"}
        children={undefined}
        subtitle={
          "Are you sure you want to delete your card? This action cannot be undone."
        }
        onProceed={async () => {
          const resp = await deleteCard({
            id: id,
          });

          if (resp.data?.success) {
            setDeleteModalOpen(false);
            onSuccess();
          }
        }}
        loading={deletingCard}
        proceedButtonText="Proceed"
      />
    </>
  );
};
